import {AlternativePaymentMethodModel} from "../alternative-payment-method.model";
import {AirlineCompanyName} from "../../../../../../global-constants";
import {IGooglePayMethodViewModel} from "./google-pay-method.view-model.interface";
import {parseCommaSeparatedValues} from "../../../../../../utils/parse-comma-separated-values";
import {Lazy} from "../../../../../../utils/lazy";
import {GooglePaymentHandler, IGooglePayConfigs} from "./google-payment-handler";
import {
    IPaymentsConfiguration,
    PaymentSupportedOS, PaymentSupportedPlatformTypes
} from "../../../../../configuration/objects/payments-configuration.interface";
import React from "react";
import {
    GooglePayPaymentMethodTabHeaderComponent
} from "../../../../../../pages/booking-flow/payment/google-pay/google-pay-payment-method-tab-header.component";
import {
    GooglePayPaymentMethodTabContentComponent
} from "../../../../../../pages/booking-flow/payment/google-pay/google-pay-payment-method-tab-content.component";
import {
    GooglePayButtonComponent
} from "../../../../../../pages/booking-flow/payment/google-pay/google-pay-button.component";


export class GooglePayMethodModel extends AlternativePaymentMethodModel implements IGooglePayMethodViewModel {

    get name(): string {
        return "Google Pay";
    }


    async canMakePayments(): Promise<boolean> {
        return await super.canMakePayments();
    }

    private get commonGooglePayConfigs(): IPaymentsConfiguration["googlePay"] {
        return this.services.configuration.data.payments.googlePay;
    }

    protected _getSupportedOS(): PaymentSupportedOS {
        return this.commonGooglePayConfigs.supportedOS;
    }

    protected _getSupportedPlatformsTypes(): PaymentSupportedPlatformTypes {
        return this.commonGooglePayConfigs.supportedPlatforms;
    }


    private _googlePaymentHandler: Lazy<GooglePaymentHandler> = new Lazy<GooglePaymentHandler>(() => {
        return new GooglePaymentHandler(this.booking, this._getGooglePayConfigs(), this.code);
    });
    private get googlePaymentHandler(): GooglePaymentHandler {
        return this._googlePaymentHandler.value;
    }

    protected async _canMakePayments(): Promise<boolean> {
        return await this.googlePaymentHandler.isReadyToPay();
    }

    createGooglePayButton(): HTMLElement | null {
        return this.googlePaymentHandler.createGooglePayButton();
    }

    _getGooglePayConfigs(): IGooglePayConfigs {
        const nuveiConfigs = this.services.configuration.data.pspConfigs.Nuvei;
        return {
            apiVersion: 2,
            apiVersionMinor: 0,
            gateway: nuveiConfigs.googleGateway,
            gatewayMerchantId: nuveiConfigs.googleGatewayMerchantId,
            environment: nuveiConfigs.environment === 'int' ? "TEST" : "PRODUCTION",
            merchantId: this.commonGooglePayConfigs.merchantId,
            merchantName: AirlineCompanyName,
            allowedAuthMethods: parseCommaSeparatedValues(nuveiConfigs.googleAllowedAuthMethods),
            allowedCardNetworks: parseCommaSeparatedValues(nuveiConfigs.googleAllowedCardNetworks),
            allowCreditCards: true,
            acquirerBankCountry: nuveiConfigs.acquirerBankCountry
        };
    }

    getSortOrder(): number {
        if(this.services.device.isAndroidMobileHybrid) {
            return 0;
        }
        return super.getSortOrder();
    }

    renderTabHeader(): React.ReactElement {
        return (
            <GooglePayPaymentMethodTabHeaderComponent/>
        );
    }

    renderTabContent(): React.ReactElement {
        return (
            <GooglePayPaymentMethodTabContentComponent/>
        );
    }

    renderPayButton(): React.ReactElement {
        return (
            <GooglePayButtonComponent googlePayMethod={this}/>
        );
    }
}
